'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps", "className", "classes", "sx"];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { ComposerHelperText } from '@mui/x-chat-headless';
import { styled, createUseThemeProps } from "../internals/zero-styled/index.mjs";
import { mergeSlotProps } from "../internals/mergeSlotProps.mjs";
import { useChatComposerUtilityClasses } from "./chatComposerClasses.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const useThemeProps = createUseThemeProps('MuiChatComposerHelperText');
const ChatComposerHelperTextStyled = styled('p', {
  name: 'MuiChatComposer',
  slot: 'HelperText',
  overridesResolver: (_, styles) => styles.helperText
})(({
  theme,
  ownerState
}) => ({
  margin: 0,
  fontSize: theme.typography.caption.fontSize,
  lineHeight: theme.typography.caption.lineHeight,
  color: ownerState?.error ? (theme.vars || theme).palette.error.main : (theme.vars || theme).palette.text.secondary,
  paddingInline: theme.spacing(0.5)
}));
const ChatComposerHelperText = /*#__PURE__*/React.forwardRef(function ChatComposerHelperText(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChatComposerHelperText'
  });
  const {
      slots,
      slotProps,
      className,
      classes: classesProp,
      sx
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = useChatComposerUtilityClasses(classesProp);
  return /*#__PURE__*/_jsx(ComposerHelperText, _extends({
    ref: ref
  }, other, {
    slots: _extends({}, slots, {
      helperText: slots?.helperText ?? ChatComposerHelperTextStyled
    }),
    slotProps: _extends({}, slotProps, {
      helperText: mergeSlotProps({
        className: clsx(classes.helperText, className),
        sx
      }, slotProps?.helperText)
    })
  }));
});
if (process.env.NODE_ENV !== "production") ChatComposerHelperText.displayName = "ChatComposerHelperText";
process.env.NODE_ENV !== "production" ? ChatComposerHelperText.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: PropTypes.object,
  className: PropTypes.string,
  slotProps: PropTypes.object,
  slots: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
export { ChatComposerHelperText };